module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en-us":{"title":"Send a test","broadcastTitle":"Send a test broadcast","inputTitle":"Phone Number","broadcastSuccess":"Test broadcast sent to {to}","success":"Test sent to {to}","error":"Error sending test message","invalidPhoneError":"Please enter a valid phone number","rateLimitError":"You’ve exceeded your 30 free \\"send a test\\" messages for today."}}')
  delete Component.options._Ctor
}
